import Cookies from 'js-cookie';

/**
 * Custom implementation of cookie storage
 * for remember me api.
 */
class CookieStorage implements Storage {
  [name: string]: any;
  length: number = 0;

  constructor() {
    // Add rehydration logic if required.
  }

  clear(): void {
    Object.keys(Cookies.get()).forEach(k => Cookies.remove(k));
  }
  getItem(key: string): string {
    return Cookies.get(key);
  }
  key(index: number): string {
    return Object.keys(Cookies.get())[index] || null;
  }
  removeItem(key: string): void {
    return Cookies.remove(key);
  }
  setItem(key: string, value: string): void {
    Cookies.set(key, value);
  }
}

/**
 * A cookie storage that expires when the browser is closed.
 */
export const cookieStorage = new CookieStorage();
